<template>
  <UpgradeDialog v-model="state.open" :detail="state.detail" />
</template>

<script>
import UpgradeDialog from './UpgradeDialog.vue';
import { upgradeState } from '../lib/upgrades';

// The upgrade dialog every locked control opens (lib/upgrades.js showUpgrade).
export default {
  name: 'UpgradeHost',
  components: { UpgradeDialog },
  computed: { state() { return upgradeState; } }
};
</script>
